__webpack_require__.p = "/sustainable-smart-garment-futures/";